import { AUTH_API_BASE_URL, urlFor, request } from '../index'

export async function getLotteryMemberList(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/lottery-thai/member-lottery-list?${params}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getLotteryLimitList(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/lottery-thai/lottery-limit-list?${params}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function addLotteryLimit(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/lottery-thai/create-limit`), {
      auth: true,
      data: data,
    })
  } catch (e) {
    return e
  }
}

export async function updateLotteryLimit(data) {
  try {
    return request('post', urlFor(AUTH_API_BASE_URL, `/lottery-thai/update-limit`), {
      auth: true,
      data: data,
    })
  } catch (e) {
    return e
  }
}

export async function getLotteryMemberResult(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/lottery-thai/lottery-member-result?${params}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getLotteryRound() {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/lottery-thai/lottery-round`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getLotteryDashboard(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/lottery-thai/lottery-dashboard?${params}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}


